import LogoImage from '../assets/images/logo.png'

export const Logo = () => {
  return <img className="mx-auto h-12 w-auto" src={LogoImage} alt="RAPA" />
}
